export const NavFullscreen = {
  transclude: true,

  bindings: {
    title: '<',
    onClick: '&',
  },

  template: `
    <nav class="navbar navbar-dark theme-dark navbar--main">
      <div class="container px-0 px-md-3 justify-content-between align-items-center">
        <div class="navbar-brand--icon d-none d-md-block">
        </div>
        <h4 class="m-0 text-white">
          {{ $ctrl.title }}
        </h4>
        <button class="btn btn-sm btn-pill bg-cz-theme-tertiary text-white"
          ng-click="$ctrl.onClick()">
          Done
        </button>
      </div>
    </nav>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavFullscreen.js